import { useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useCurrentUserId } from "./use-current-user";

type ActivityType = "course" | "module" | "activity" | "quiz";
type ActionType = "viewed" | "started" | "completed" | "resumed" | "downloaded" | "shared";

interface LogActivityParams {
  activityType: ActivityType;
  entityType: string;
  entityId: string;
  entityTitle?: string;
  action: ActionType;
  metadata?: Record<string, any>;
}

export function useActivityLogger() {
  const { data: userId } = useCurrentUserId();

  const logActivity = useCallback(async (params: LogActivityParams) => {
    try {
      if (!userId) return;

      const { error } = await supabase
        .from("user_activity_logs")
        .insert({
          user_id: userId,
          activity_type: params.activityType,
          entity_type: params.entityType,
          entity_id: params.entityId,
          entity_title: params.entityTitle,
          action: params.action,
          metadata: params.metadata || {}
        });

      if (error) {
        console.error("Error logging activity:", error);
      }
    } catch (error) {
      console.error("Error in logActivity:", error);
    }
  }, [userId]);

  return { logActivity };
}
